"use client";

import { useEffect, useState } from "react";
import { getSessionAction } from "@/actions/serverActions/auth/getSessionAction";

/**
 * Returns the array of permission codenames held by the current user,
 * or `[]` while the session is loading / unavailable.
 *
 * Read-only — `getSessionAction` is CSRF-free per its docstring, so we
 * call it directly from a `useEffect` (no `useServerAction` wrapper).
 *
 * Used by the sidebar / search to hide nav items whose
 * `requiredPermission` codename is not held by the current user.
 */
export function useUserCodenames(): string[] {
  const [codenames, setCodenames] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    getSessionAction()
      .then((session) => {
        if (cancelled) return;
        const perms = session?.user?.permissions ?? [];
        setCodenames(
          perms
            .map((p) => p?.codename)
            .filter((c): c is string => typeof c === "string" && c.length > 0),
        );
      })
      .catch(() => {
        // Leave codenames as [] — gated items stay hidden on error.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return codenames;
}
